// extracted by mini-css-extract-plugin
export default {"divider":"_1s18d9p"};